import nuevo3 from '../images/content-master/nuevo3.jpg';
import nuevo4 from '../images/content-master/nuevo4.jpg';
import nuevo5 from '../images/content-master/nuevo5.png';
import AngryBirds from '../images/content-master/Angrybirds.jpeg';
import Nyxarion from '../images/content-master/Nyxarion.jpg';
import Nubi from '../images/content-master/Nubi.jpg';
import Zoru from '../images/content-master/Zoru.jpg';

const contentMaster = [
	{
		id: '01',
		title: 'Nyxarion',
		image: Nyxarion,
		imageWebp: Nyxarion,
		description: 'Domina el arte de la escultura creando este fantástico personaje en Blender',
		video: '',
		software: ['blender'],
	},
	{
		id: '02',
		title: 'Nubi',
		image: Nubi,
		imageWebp: Nubi,
		description: 'Inicia tu proceso de adaptación de la mejor manera y marca tu proceso',
		video: '',
		software: ['blender'],
	},
	{
		id: '03',
		title: 'Zoru',
		image: Zoru,
		imageWebp: Zoru,
		description:
			'Ya has iniciado tu curva de aprendizaje ahora vamos a encontrar tu flujo de trabajo en Blender',
		video: '',
		software: ['blender'],
	},
	// {
	// 	id: '04',
	// 	title: 'Angry Birds',
	// 	image: AngryBirds,
	// 	imageWebp: AngryBirds,
	// 	description:
	// 		'Aprende paso a paso y crear tu primer personaje en Blender aplicando técnicas de escultura digital',
	// 	video: '',
	// 	software: ['blender'],
	// },
	// {
	// 	id: '05',
	// 	title: 'Night Rabbit',
	// 	image: nuevo3,
	// 	imageWebp: nuevo3,
	// 	description: 'Iníciate en el mundo de Blender desde cero y logra increíbles resultados',
	// 	video: '',
	// 	software: ['blender'],
	// },
	// {
	// 	id: '06',
	// 	title: 'Creando a JIN',
	// 	image: nuevo4,
	// 	imageWebp: nuevo4,
	// 	description: 'Sigue tu proceso de aprendizaje y crea este fantástico panda desde cero',
	// 	video: '',
	// 	software: ['blender'],
	// },
	{
		id: '04',
		title: 'Niño warrior',
		image: nuevo5,
		imageWebp: nuevo5,
		description:
			'Sigue tu curva de aprendizaje creando este fantástico personaje aplicando técnicas de escultura en Blender',
		video: '',
		software: ['blender'],
	},
];

export default contentMaster;
